import React, { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext } from '../../context/ModalContext';
import CancelIcon from '../Icons/CancelIcon';

interface ModalContainerProps {
  children: React.ReactNode;
  label?: string;
  description?: string;
}
const ModalContainer: React.FC<ModalContainerProps> = ({
  children,
  label,
  description,
}) => {
  const modalContext = useContext(ModalContext);
  const onClickCancel = (e: any) => {
    modalContext?.setShowModal(false);
  };

  return (
    <Container
      onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
      }}
    >
      <HeaderSection>
        <HeaderArea>
          <Header>{label}</Header>
          <IconContainer onClick={onClickCancel}>
            <CancelIcon />
          </IconContainer>
        </HeaderArea>
        {description && <Description>{description}</Description>}
      </HeaderSection>
      {children}
    </Container>
  );
};

export default ModalContainer;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 48px;
  border-radius: 15px;
  background-color: white;
  width: 620px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  box-shadow: 0 4px 28px 0 rgba(0, 0, 0, 0.08);
  gap: 20px;
  margin-top: 132px;

  @media (max-width: 884px) {
    /* border: 2px solid red; */
    width: 100vw;
    height: 100vh;
    padding: 3.63rem 1rem;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  /* border: 2px solid red; */
`;

const HeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Header = styled.div`
  font-weight: 700;
  font-size: 32.11px;
  line-height: 32.11px;
`;

const IconContainer = styled.div`
  /* border: 2px solid red; */
  margin-top: -20px;
  margin-right: -20px;
  cursor: pointer;

  transform: scale(100%);
  transition: transform 0.3s ease-out;

  &:hover {
    transform: scale(110%);
  }
`;

const Description = styled.div`
  font-size: 17px;
  color: #374151;
`;
